import React, { useState } from "react";
import one from "../../assets/Inventory/Stockout.svg";
import two from "../../assets/Inventory/Low_on_Inventory.svg";
import three from "../../assets/Inventory/High_on_Inventory.svg";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

const VendorHighLowTiles = ({ data }) => {
    const { t, i18n } = useTranslation();

    console.log("vendor high low data", data);


    const values = {
        1: {
            img: two,
            heading: t("Low on Inventory"),
            productsleft: `${data?.low_on_inventory || "0"
                } `,
            bgcolor: "#D1F1FC",
            textcolor: "#374151",
        },
        2: {
            img: three,
            heading: t("High on Inventory"),
            productsleft: `${data?.high_on_inventory || "0"
                }`,
            bgcolor: "#D1F1FC",
            textcolor: "#374151",
        },
        3: {
            img: one,
            heading: t("Out of Stock"),
            productsleft: `${data?.out_of_stock || "0"} `,
            bgcolor: "#D1F1FC",
            textcolor: "#374151",
        },
        4: {
            img: three,
            heading: t("Healthy Inventory"),
            productsleft: `${data?.healthy_inventory || "0"} `,
            bgcolor: "#D1F1FC",
            textcolor: "#374151",
        },
    };

    const tileValues = values;

    return (
        <div className="flex flex-wrap mt-2  mb-2">
            {Object.values(tileValues).map((val, index) => (
                <div key={index} className="w-1/2 md:w-1/4 px-2 mb-2">
                    <div
                        style={{ backgroundColor: val.bgcolor }}
                        className="w-full h-20 rounded-lg flex items-center p-1 shadow-sm relative"
                    >
                        <div className="me-2">
                            <img src={val.img} alt={val.heading} width={35} height={35} />
                        </div>
                        <div>
                            <p className="font-normal text-base text-clip">{val.heading}</p>
                            <p
                                style={{ color: val.textcolor }}
                                className="font-bold text-xl truncate"
                            >
                                {val.productsleft}
                            </p>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default VendorHighLowTiles;
